import { UIOnlyFields } from '@/types';
import { messages } from '@/messages';
import * as yup from 'yup';
import { SiteApplicationInput, SiteSource, SiteType } from '@/gql/graphql';

export const formIntialState: UIOnlyFields & SiteApplicationInput = {
  name: '',
  firstName: '',
  lastName: '',
  email: '',
  jobTitle: '',
  phone: '',
  siteType: undefined,
  organization: '',
  address1: '',
  country: '',
  city: '',
  stateProvince: '',
  postalCode: '',
  url: '',
  hasMultiLocations: undefined,
  isUniqueSite: undefined,
  hasSmoContract: undefined,
  smoAddress1: '',
  smoCountry: '',
  smoCity: '',
  smoState: '',
  smoZip: '',
  marketingSource: '',
  referralSource: '',
  studiesPerYear: undefined,
  emailOptIn: false,
  asCRO: undefined,
  agreedToTOS: false,
  addressAutocompleteLabel: '',
  addressAutocompleteKey: '',
  siteSource: SiteSource.SvApp,
};

//An object of UI only fileds that need to be removed from the payload before sending it to the server
export const uiOnlyFields: UIOnlyFields = {
  asCRO: undefined,
  agreedToTOS: undefined,
  addressAutocompleteLabel: '',
  addressAutocompleteKey: '',
};

//Validation schemas
export const personalDetailsValidationSchema = yup.object({
  firstName: yup.string().required(messages['validation.genericRequired']),
  lastName: yup.string().required(messages['validation.genericRequired']),
  email: yup.string().email().required(messages['validation.genericRequired']),
  jobTitle: yup.string().required(messages['validation.genericRequired']),
  phone: yup.string().required(messages['validation.genericRequired']),
});

export const siteDetailsValidationSchema = yup.object({
  siteType: yup.string().required(messages['validation.genericRequired']),
  organization: yup.string().required(messages['validation.genericRequired']),
  name: yup
    .string()
    .required(messages['validation.genericRequired'])
    .max(128, messages['validation.max128']),
  address1: yup
    .string()
    .required(messages['validation.genericRequired'])
    .max(75, messages['validation.max75']),
  country: yup.string().required(messages['validation.genericRequired']),
  stateProvince: yup.string().required(messages['validation.genericRequired']),
  city: yup.string().required(messages['validation.genericRequired']),
  postalCode: yup.string().required(messages['validation.genericRequired']),
  url: yup.string().required(messages['validation.genericRequired']),
  hasMultiLocations: yup.boolean().when(['siteType'], {
    is: (siteType) => siteType === SiteType.PrivatePractice,
    then: yup.boolean().required(messages['validation.genericRequired']),
    otherwise: yup.boolean(),
  }),
  isUniqueSite: yup.boolean().when(['hasMultiLocations'], {
    is: true,
    then: yup.boolean().required(messages['validation.genericRequired']),
  }),
  smoAddress1: yup.string().when(['siteType'], {
    is: (siteType) => siteType === SiteType.Smo,
    then: yup
      .string()
      .required(messages['validation.genericRequired'])
      .max(75, messages['validation.max75']),
    otherwise: yup.string(),
  }),
  hasSmoContract: yup.boolean().when(['siteType'], {
    is: (siteType) => siteType === SiteType.Smo,
    then: yup.boolean().required(messages['validation.genericRequired']),
    otherwise: yup.boolean(),
  }),
  smoCountry: yup.string().when(['siteType'], {
    is: (siteType) => siteType === SiteType.Smo,
    then: yup.string().required(messages['validation.genericRequired']),
    otherwise: yup.string(),
  }),
  smoCity: yup.string().when(['siteType'], {
    is: (siteType) => siteType === SiteType.Smo,
    then: yup.string().required(messages['validation.genericRequired']),
    otherwise: yup.string(),
  }),
  smoState: yup.string().when(['siteType'], {
    is: (siteType) => siteType === SiteType.Smo,
    then: yup.string().required(messages['validation.genericRequired']),
    otherwise: yup.string(),
  }),
  smoZip: yup.string().when(['siteType'], {
    is: (siteType) => siteType === SiteType.Smo,
    then: yup.string().required(messages['validation.genericRequired']),
    otherwise: yup.string(),
  }),
});

export const lastStepValidationSchema = yup.object({
  marketingSource: yup.string().required(messages['validation.genericRequired']),
  asCRO: yup.boolean().required(messages['validation.genericRequired']),
  referralSource: yup.string().when(['asCRO'], {
    is: (asCRO) => asCRO === true,
    then: yup.string().required(messages['validation.genericRequired']),
    otherwise: yup.string(),
  }),
  studiesPerYear: yup.string().required(messages['validation.genericRequired']),
  agreedToTOS: yup.boolean().required().oneOf([true], messages['validation.genericRequired']),
});

export const inviteFlowSiteDetailsValidationSchema = siteDetailsValidationSchema.concat(
  yup.object({
    agreedToTOS: yup.boolean().required().oneOf([true], messages['validation.genericRequired']),
  })
);
